<template>
  <div class="list-wrapper">
    <div class="content-wrapper">
      <div class="h-full">
        <div class="c_group">
          <query-form
            class="content_block"
            label-width="100px"
            size="small"
            label-position="right"
            @search="getList('init')"
            @reset="handleReset"
            :keepOpenedRow="2">
            <el-form-item label="售后状态" :span="24">
              <check-tag v-model="advancedForm.status" @change="() => getList('init')">
                <check-tag-item
                  :value="i.value"
                  :key="i.value"
                  v-for="i in executionStatusGroup2"
                  :label="`${i.label}(${i.count || 0})`"
                ></check-tag-item>
              </check-tag>
            </el-form-item>
            <el-form-item label="订单编号">
              <el-input
                v-model.trim="advancedForm.orderCode"
                clearable
                placeholder="请输入订单编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="客户抬头">
              <el-input
                v-model.trim="advancedForm.customerName"
                clearable
                placeholder="请输入客户抬头"
              ></el-input>
            </el-form-item>
            <el-form-item label="售后单号">
              <el-input
                v-model.trim="advancedForm.outRefundCode"
                clearable
                placeholder="请输入售后单号"
              ></el-input>
            </el-form-item>
            <el-form-item label="售后类型">
              <el-select
                v-model.trim="advancedForm.type"
                clearable
                placeholder="请选择"
                @change="getList('init')"
              >
                <el-option
                  v-for="item in typeStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="退货状态">
              <el-select
                v-model.trim="advancedForm.goodsStatus"
                clearable
                placeholder="请选择"
                @change="getList('init')"
              >
                <el-option
                  v-for="(item, index) in returnStatusOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="退款状态">
              <el-select
                v-model.trim="advancedForm.moneyStatus"
                clearable
                placeholder="请选择"
                @change="getList('init')"
              >
                <el-option
                  v-for="item in refundStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申请日期(起)">
              <el-date-picker
                v-model="advancedForm.createTimeStart"
                type="date"
                value-format="yyyy-MM-dd 00:00:00"
                placeholder="请选择申请日期(起)"
                style="width: 100%;"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="申请日期(止)">
              <el-date-picker
                v-model="advancedForm.createTimeEnd"
                type="date"
                value-format="yyyy-MM-dd 23:59:59"
                placeholder="请选择申请日期(止)"
                style="width: 100%;"
              >
              </el-date-picker>
            </el-form-item>
          </query-form>
        </div>
        <div class="table-wrapper" :class="{ 'fullscreen': isFullScreen }">
          <xz-table
            ref="xzTable"
            :columns="columnList"
            :data="dataList"
            :toolsAttrs="toolsAttrs"
            :scroll="{ x: '100%', y: scrollHeight }"
            rowKey="id"
            :isNest="true"
            :expandedRowKeys.sync="expandedRowKeys"
            @openCloseAll="openCloseAll"
            @refresh="handleReset"
            @fullScreen="handleFullScreen"
            @expand="expandedOneRow">
            <template v-if="showUpdateDelivery && $withPermission('gongxutong:sale_after:order:sync')" #buttons>
              <el-button type="primary" size="mini" @click="handleUpdate">售后订单更新</el-button>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>售后订单更新前，请确保订单更新完成，否则售后订单可能更新不成功。</span>
                </template>
                <a-icon type="exclamation-circle" style="font-size: 14px;" />
              </a-tooltip>
            </template>
            <template #custom>
              <tableHeaderConfiguration businessType="afterSales" :disabledList="disabledList" :baseLists="baseLists" @updateColumnList="updateColumnList" />
            </template>
            <div slot="action" slot-scope="_, row">
              <a v-if="$withPermission('gongxutong:sale_after:order:detail')" @click="() => operate('detail', row)">查看</a>
              <a v-if="row.status === 2 && $withPermission('gongxutong:sale_after:order:audit')" style="margin-left: 8px" @click="() => operate('review', row)">审核</a>
              <!-- 换货单：供应商已确认收到全部退货、补发未完成时可补发 -->
              <a
                v-if="row.dockingSystem === 'XIAOZI_MIDDLE' && row.type === 4 && row.status === 3 && row.receiveStatus === 3 && [1, 2].includes(row.redeliveryStatus) && $withPermission('gongxutong:sale_after:order:redelivery')"
                style="margin-left: 8px"
                @click="() => $router.push({ path: '/afterSaleManagement/service/redelivery', query: { id: row.id } })">补发</a>
            </div>
            <xz-table
              rowKey="id"
              class="subTable"
              slot="expandedRowRender"
              slot-scope="row"
              :columns="subColumnsLists"
              :data="row.goodsList">
              <template slot="imageList" slot-scope="image">
                <span v-if="image && image.split(',').length > 0">
                  <span v-for="(img, i) in image.split(',')" :key="'img-'+i">
                    <el-image v-if="i < 2" style="width: 32px; height: 32px; margin-right: 5px;" :src="img" :preview-src-list="image.split(',')" />
                  </span>
                  <span v-if="image.split(',').length > 2" style="color:#3182bd; margin-left: 2px;">...</span>
                </span>
                <span v-else>暂无图片</span>
              </template>
              <template slot="tdAction" slot-scope="currentReturnNum, record">
                <div @click="handleShowReturnDialog(record, row)" style="color: #237FFA; cursor: default;">{{ currentReturnNum }}</div>
              </template>
              <template slot="footer" slot-scope="currentPageData">
                <div>
                  <b style="margin-right: 100px;">合计</b>
                  <b style="margin-right: 5px;">数量：{{ currentPageData.reduce((pre, cur) => pre + cur.quantity, 0) || '-' }}</b>
                  <b>，总金额：{{ currentPageData.reduce((pre, cur) => pre + cur.quantity * cur.taxPrice, 0).toLocaleString('en-US', { minimumFractionDigits: 2 }) || '-' }}</b>
                </div>
              </template>
            </xz-table>
          </xz-table>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <a-pagination
        :current="pagination.pageNum"
        :total="total"
        :show-total="total => `共 ${total || 0} 条`"
        show-size-changer
        :pageSizeOptions="['10', '20', '30', '50', '100']"
        show-quick-jumper
        :pageSize.sync="pagination.pageSize"
        @change="handleNumChange"
        @showSizeChange="handleSizeChange"
      />
    </div>
    <ReturnDialog ref="returnDialogRef" />
  </div>
</template>
<script>
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';
import { afterQueryPage, queryStateInfoBySeller, pullXzErpRefund } from '@/api/service';
import setTableCols from './configs';
import ReturnDialog from '../components/returnDialog.vue';
import { tenantDetail } from '@/api/shop';
import {
  executionStatusGroup2,
  refundStatusOptions,
  returnStatusOptions,
  typeStatusOptions,
} from '@/model/service';

export default {
  name: 'service',
  components: {
    xzTable,
    tableHeaderConfiguration,
    ReturnDialog,
  },
  watch: {
    applyDate (val) {
      if (val) {
        this.advancedForm.createTimeStart = val[0];
        this.advancedForm.createTimeEnd = val[1];
      } else {
        this.advancedForm.createTimeStart = undefined;
        this.advancedForm.createTimeEnd = undefined;
      }
    },
  },
  computed: {
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        // advancedSearch: true,
        custom: true,
      };
    },
  },
  data () {
    return {
      expandedRowKeys: [],
      showUpdateDelivery: false,
      disabledList: ['code', 'type', 'status', 'customerName'],
      dataList: [],
      advancedForm: {
        status: '',
      },
      applyDate: [],
      executionStatusGroup2,
      refundStatusOptions,
      returnStatusOptions,
      typeStatusOptions,
      columnList: [
        ...setTableCols.call(this),
      ],
      baseLists: [
        ...setTableCols.call(this),
      ],
      subColumnsLists: [
        ...setTableCols.call(this, 'serviceList'),
        {
          title: '注册证号',
          dataIndex: 'certificateNumber',
          key: 'certificateNumber',
          width: 120,
          ellipsis: true,
          customRender: text => {
            return text || '--';
          },
        },
        {
          title: '退货数量',
          dataIndex: 'quantity',
          key: 'quantity',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'tdAction' },
        },
      ],
      scrollHeight: 'calc(100vh - 220px - 70px - 110px)',
      isFullScreen: false,
      total: 0,
      pagination: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  async created () {
    if (this.$route.query.status || this.$route.query.status === 0) {
      this.advancedForm.status = this.$route.query.status + '';
    }

    const userInfo = this.$local.get('userInfo') ? JSON.parse(this.$local.get('userInfo')) : {};
    const { body } = await tenantDetail({
      id: userInfo.tenantId,
      findActivateServiceFlag: true,
    });
    if (body.activateService && body.activateService.includes('小紫VIS')) {
      this.showUpdateDelivery = true;
    }

    this.getList();
    this.getSaleContractCount();
  },
  methods: {
    updateColumnList (columnList) {
      this.columnList = [
        ...columnList,
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 140,
          scopedSlots: { customRender: 'action' },
        },
      ];
      setTimeout(() => {
        this.expandedRowKeys = [];
        this.$refs.xzTable.addElementsToClass();
      }, 0);
    },
    handleFullScreen () {
      this.isFullScreen = !this.isFullScreen;
    },
    handleSizeChange (_, size) {
      this.pagination.pageSize = size;
      this.getList();
    },
    handleNumChange (num) {
      this.pagination.pageNum = num;
      this.getList();
    },
    openCloseAll () {
      setTimeout(() => {
        this.expandedRowKeys.forEach((key) => {
          const elements = document.querySelectorAll(`[data-row-key='${key}-extra-row']`);
          const length = elements.length;
          const height = elements[0].offsetHeight - 18.6;
          const tableContents = elements[0].querySelectorAll('.ant-table-content');
          if (tableContents.length) {
            for (let i = 0; i < tableContents.length; i++) {
              tableContents[i].style.paddingRight = 200 + 'px';
            }
          }

          elements[length - 1].childNodes[0].innerHTML = `<div style='height: ${height}px;'></div>`;

          // 设置fixed-left时，子表格paddingRight为0
          const fixedTableLeft = document.querySelectorAll('.ant-table-fixed-left');
          if (fixedTableLeft.length) {
            const fixedRows = fixedTableLeft[0].querySelectorAll(`[data-row-key='${key}-extra-row']`);
            if (fixedRows.length) {
              const fixedRowsSecondTd = fixedRows[0].querySelectorAll('td')[1];
              if (fixedRowsSecondTd) {
                fixedRowsSecondTd.style.paddingRight = 0;
              }
            }
          }
        });
      }, 0);
    },
    expandedOneRow (_, rec) {
      setTimeout(() => {
        const elements = document.querySelectorAll(`[data-row-key='${rec.id}-extra-row']`);
        const length = elements.length;
        const height = elements[0].offsetHeight - 18.6;
        const tableContents = elements[0].querySelectorAll('.ant-table-content');

        if (tableContents.length) {
          for (let i = 0; i < tableContents.length; i++) {
            tableContents[i].style.paddingRight = 200 + 'px';
          }
        }

        elements[length - 1].childNodes[0].innerHTML = `<div style='height: ${height}px;'></div>`;

        // 设置fixed-left时，子表格paddingRight为0
        const fixedTableLeft = document.querySelectorAll('.ant-table-fixed-left');
        if (fixedTableLeft.length) {
          const fixedRows = fixedTableLeft[0].querySelectorAll(`[data-row-key='${rec.id}-extra-row']`);
          if (fixedRows.length) {
            const fixedRowsSecondTd = fixedRows[0].querySelectorAll('td')[1];
            if (fixedRowsSecondTd) {
              fixedRowsSecondTd.style.paddingRight = 0;
            }
          }
        }
      }, 0);
    },
    async handleUpdate () {
      const { body } = await pullXzErpRefund({});
      this.$message.success(`更新成功，共更新 ${body} 条数据`);
      this.handleReset();
    },
    getList (type) {
      if (type === 'init') {
        this.total = 0;
        this.pagination = {
          pageNum: 1,
          pageSize: 10,
        };
      }

      let { pageSize, pageNum } = this.pagination;
      let orderBy = [
        {
          orderByProperty: 'lastUpdateTime',
          orderByType: 'DESC',
        },
      ];

      afterQueryPage({
        ...this.advancedForm,
        findRefundGoodsFlag: true,
        orderBy,
        pageSize,
        pageNum,
      }).then(
        ({ body }) => {
          this.dataList = body.list;
          this.total = +body.total || 0;
          setTimeout(() => {
            this.expandedRowKeys = [];
            this.$refs.xzTable.addElementsToClass();
          }, 0);
        },
      );
    },
    getSaleContractCount () {
      queryStateInfoBySeller().then(({ body }) => {
        for (let v of this.executionStatusGroup2) {
          v.count = body[v.en];
        }
        this.executionStatusGroup2[0].count = this.executionStatusGroup2.reduce((pre, cur) => pre + (cur.count || 0), 0);
      });
    },
    handleReset () {
      for (let key in this.advancedForm) {
        this.advancedForm[key] = '';
      }

      this.total = 0;
      this.pagination = {
        pageNum: 1,
        pageSize: 10,
      };

      this.getList();
    },
    operate (type, row) {
      // 小紫中台来源：详情、审核都读平台本地数据
      if (row.dockingSystem === 'XIAOZI_MIDDLE') {
        this.$router.push({
          path: '/afterSaleManagement/service/middleDetail',
          query: {
            id: row.id,
            type,
          },
        });
        return;
      }
      let path = '/afterSaleManagement/service/detail';

      if (type !== 'detail') {
        path = '/afterSaleManagement/service/review';
      }

      this.$router.push({
        path,
        query: {
          id: row.id,
          outRefundId: row.outRefundId,
          returnType: row.type,
          type,
        },
      });
    },
    handleShowReturnDialog (record, row) {
      if (row.dockingSystem === 'XIAOZI_MIDDLE') {
        this.$refs.returnDialogRef.showMiddleRefundGoods(record);
        return;
      }
      this.$refs.returnDialogRef.id = row.outRefundId;
      this.$refs.returnDialogRef.getRefundReturnGoods({ ...row, id: record.outRefundGoodsId});
    },
  },
};
</script>
<style lang='scss' scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}
.list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 8px;

    .h-full {
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .c_group {
        position: relative;

        .content_block {
          border-bottom: 0.5px solid #DFE2E8;
          padding: 10px;
        }

        .title {
          font-size: 14px;
          font-weight: 600;
          padding-right: 2em;
        }
      }

      .table-wrapper {
        padding: 16px 12px;
        flex: 1;
        overflow: auto;

        .ant-radio-button-wrapper {
          border-width: 0;
          background-color: #f2f4f7;

          &.active-radio {
            border-color: #e2f3fe;
            background-color: #e2f3fe;
            color: #237ffa;
          }
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          width: 0;
        }
      }
    }
  }

  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #FFFFFF;
  }
  /deep/ .contract-option {
    color: #02a7f0;
    cursor: pointer;
    padding: 0 0.25em;
  }

  .el-range-editor--small.el-input__inner {
    width: 100%;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
}
/deep/.ant-table-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #c9ced6;
  background: #c9ced6;
}

//鼠标移入样式
/deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #c9ced6;
}

/deep/.ant-drawer-body {
  padding: 16px;
}
</style>
